<!-- Input de cep com pesquisa

//utilização:
  <input-cep
    v-on:update="updateCep"
    name="cep"
    v-model="entity.part.cep"
    v-validate="{numeric: true, min: 2, max: 8}"></input-cep>

//eventos emit
v-on:update

-->

<template>
    <input
      type="text"
      v-on:keyup="buscaCep"
      v-bind:value="cep"
      v-on:input="updateValue($event.target.value)"
      v-on:blur="formatValue"
      ref="cep"
      @keydown.enter="focusControl">
</template>

<script>
//https://br.vuejs.org/v2/guide/components.html#Usando-v-on-com-Eventos-Personalizados

import { SysVars } from '../main';
import { apiORDSapp } from '../shared/api-functions'
import { hasHiddenParent } from '../shared/utils';

export default {
    props: {
      'value': String
    },

    data () {
      return {
        cep: this.value,
        fucused: false
      }
    },
    created () {

    },

    watch: {
      value: function (newValue) {
        this.cep = newValue
        this.formatValue()
      }
    },

    methods: {
      buscaCep () {
        var vm = this
        if (/^[0-9]{5}[0-9]{3}$/.test(this.cep)) {

          apiORDSapp(this, 'cep/?cep=' + this.cep, 'get')
            .then(data => {
              console.log('input-cep buscaCep')
              if (data.erro) {
                SysVars.endereco = {}
              } else {
                //atualiza a SysVars com o endereco
                SysVars.endereco = data
                SysVars.endereco.logradouro = vm.$removerAcentos(SysVars.endereco.logradouro.toUpperCase())
                SysVars.endereco.bairro = vm.$removerAcentos(SysVars.endereco.bairro.toUpperCase())
                SysVars.endereco.localidade = vm.$removerAcentos(SysVars.endereco.localidade.toUpperCase())
                vm.$emit('update')

              }
            })

          // jQuery.getJSON(vm.$store.getters.urlApp + 'cep/?cep=' +this.cep, function(data) {
          //   if (data.erro) {
          //     SysVars.endereco = {}
          //   } else {
          //     //atualiza a SysVars com o endereco
          //     SysVars.endereco = data
          //     SysVars.endereco.logradouro = vm.$removerAcentos(SysVars.endereco.logradouro.toUpperCase())
          //     SysVars.endereco.bairro = vm.$removerAcentos(SysVars.endereco.bairro.toUpperCase())
          //     SysVars.endereco.localidade = vm.$removerAcentos(SysVars.endereco.localidade.toUpperCase())
          //     vm.$emit('update')
          //   }
          // })
        }
      },

      updateValue: function(value) {
        this.cep = value.replace(/\D/g, '')
        this.$emit('input', this.cep)
      },

      formatValue: function() {
        this.focused = false
        if (this.$refs.cep.value) {
          this.$refs.cep.value = this.cep.replace(/\D/g, '').replace(/^(\d{5})(\d{3})??/, "$1-$2")
        }
      },

      selectAll: function(event) {
        if (this.focused == false){
          this.formatRemove()
        }
        this.focused = true
        // Workaround for Safari bug
        // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
        setTimeout(function() {
          event.target.select()
        }, 0)
      },

      formatRemove: function () {
        if (this.$refs.cep.value) {
          this.$refs.cep.value = this.cep.replace(/\D/g, '')
        }
      },

      focusControl: function (event) {
          event.preventDefault();
          var thisIndex = jQuery(this.$el).index(SysVars.sFocusControl)
          var next = thisIndex + 1
          var obj = jQuery(SysVars.sFocusControl)
          let found = false
          for (var x = next; x < obj.length; x++) {
            if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
              jQuery(obj[x]).focus()
              found = true
              break
            }
          }
          if (!found) {
            for (var x = 0; x < obj.length; x++) {
              if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
                jQuery(obj[x]).focus()
                found = true
                break
              }
            }
          }

          this.$emit('keyenter')
      },

      focus: function () {
          if (this.$refs.cep) {
              this.$refs.cep.focus()

          }
      },

    },

}
</script>

<style scoped>
  input {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/input-cep.vue